import { checklistenAnzeigeName } from '@pilot-hub/ui'

/** Lesbarer Titel einer Checkliste: Phase statt interner Vorlagenkennung (z. B. „Führung_Übung_Einsatzbereitschaft“) */
export const PHASE_TEXT: Record<string, string> = {
  EINSATZBEREITSCHAFT: 'Einsatzbereitschaft', ANFAHRT_BRIEFING: 'Anfahrt & Briefing', EINSATZENDE: 'Einsatzende',
  EINSATZORT: 'Am Einsatzort', VORFLUG: 'Vorflugkontrolle', START: 'Vor dem Start', LANDUNG: 'Landung',
  NACHFLUG: 'Nachflugkontrolle', EINSATZENDE_PILOT: 'Einsatzende',
}

export const MODUL_TEXT: Record<string, string> = { FUEHRUNG: 'Führung', PILOT: 'Pilot', ADMIN: 'Admin' }

/** typ = Einsatztyp: bei UEBUNG „Übungsbereitschaft“ statt „Einsatzbereitschaft“ */
export const checklistenTitel = (i: { name: string; phase?: string | null }, typ?: string | null) =>
  (i.phase && (checklistenAnzeigeName(i.phase, typ) || PHASE_TEXT[i.phase])) || i.name.split('_').pop()?.replace(/([a-zäöü])([A-Z])/g, '$1 $2') || i.name
